import { AndroidBridge } from './AndroidBridge'
import { IOSBridge } from './IOSBridge'
import { detectPlatform, Platform } from './platform'

function createBridge() {
  if (typeof window === 'undefined') return undefined

  const platform = detectPlatform()

  if (platform === Platform.ANDROID) {
    const instance = new AndroidBridge()
    return Object.freeze(instance)
  }

  if (platform === Platform.IOS) {
    const instance = new IOSBridge()
    return Object.freeze(instance)
  }

  return undefined
}

export const bridge =
  globalThis.__ACCOUNTS_WEBVIEW_BRIDGE__ ||
  (globalThis.__ACCOUNTS_WEBVIEW_BRIDGE__ = createBridge())
